<template>
    <div>
        <div v-if="item" class="px-2">
           <div class="row">
                <div class="col-sm-12 nopads pr-1 pl-1">
                    <span class="span-title">{{ $t('road_sign.sign_type') }}</span>
                    <select
                        v-model="item.type"
                        :class="['form-select form-select-sm', { 'is-invalid': !item.type, 'is-valid': item.type !== null && item.type !== '' }]"
                    >
                        <option :value="null" disabled>
                            {{ $t('road_sign.select_sign_type') }}
                        </option>
                        <option
                            v-for="type in getRoadSignTypes()"
                            :key="type.value"
                            :value="type.value"
                        >
                            {{ type.name }}
                        </option>
                    </select>
                </div>
            </div>
           <div class="row">
                <div class="col-sm-12 nopads pr-1 pl-1">
                    <span class="span-title">{{ $t('road_sign.road_sign') }}</span>
                    <multiselect
                        :class="[!item.sign ? 'validationError' : '']"
                        v-model="item.sign"
                        :placeholder="$t('road_sign.select_sign')"
                        :deselect-label="$t('common.remove_selection')"
                        :select-label="$t('common.select')"
                        :close-on-select="true"
                        :multiple="false"
                        label="name"
                        track-by="name"
                        :searchable="true"
                        :internal-search="true"
                        :selected-label="$t('common.selected')"
                        :options="signs"
                        >
                        <template #singleLabel="props"
                        >
                            <div class="row">
                                <div class="col-auto p-0">
                                    <img class="option__image"
                                         :src="getRoadSignImage(props.option.icon)"
                                         height="25px"
                                         alt=""
                                    >
                                </div>
                                <div class="col" style="padding-top: 2px;">
                                    <span class="option__title" style="font-weight: 400;">
                                        {{ props.option.name }}
                                    </span>
                                </div>
                            </div>
                        </template>
                        <template #option="props">
                            <div class="row">
                                <div class="col-auto p-0">
                                    <img class="option__image"
                                         :src="getRoadSignImage(props.option.icon)"
                                         height="35px"
                                         alt=""
                                    >
                                </div>
                                <div class="col pt-2">
                                    <span class="option__title pt-2">
                                        {{ props.option.name }}
                                    </span>
                                </div>
                            </div>
                        </template>
                        <template #noResult>{{ $t('common.not_found') }}</template>
                        <template #noOptions>{{ $t('common.no_results') }}</template>
                    </multiselect>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4">
                    <span class="span-title">{{ $t('road_sign.sign_value') }}</span>
                    <input
                        v-model="item.value"
                        type="number"
                        :placeholder="$t('road_sign.value_hint')"
                        class="form-control form-control-sm"
                        id="value"
                    />
                </div>
                <div class="col-sm-4">
                    <span class="span-title">{{ $t('road_sign.road_direction') }}</span>
                    <input
                        v-model="item.direction"
                        type="number"
                        min="1"
                        max="3"
                        class="form-control form-control-sm"
                        id="value"
                    />
                </div>
                <div class="col-sm-4">
                    <span class="span-title">{{ $t('road_sign.sign_lane') }}</span>
                    <input
                        v-model="item.lane"
                        type="number"
                        min="1"
                        class="form-control form-control-sm"
                        id="value"
                    />
                </div>
            </div>

            <div class="row">
                <div class="col-sm-4">
                    <span class="span-title">{{ $t('road_sign.installation') }}</span>
                    <select v-model="item.installation" class="form-select form-select-sm">
                        <option :value="null" disabled>{{ $t('road_sign.select_installation') }}</option>
                        <option v-for="installation in getVelhoInstallations()" :key="installation.value" :value="installation.value">
                            {{ installation.name }}
                        </option>
                    </select>
                </div>
                <div class="col-sm-4">
                    <location-deviation :editMode="true" :locationDeviation="item.location_deviation" @updateLocationDeviation="updateLocationDeviation"/>
                </div>
                <div class="col-sm-4">
                    <span class="span-title">{{ $t('road_sign.material') }}</span>
                    <select
                        v-model="item.material"
                        class="form-select form-select-sm"
                        :class="{'is-invalid': !item.material,'is-valid': item.material}">
                        <option :value="null">{{ $t('road_sign.select_material') }}</option>
                        <option v-for="material in getMaterials()" :key="material.value" :value="material.value">
                            {{ material.name }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-4">
                    <span class="span-title">{{ $t('road_sign.sign_direction') }}</span>
                    <input
                        v-model="item.sign_direction"
                        type="number"
                        min="0"
                        max="359"
                        :placeholder="$t('road_sign.direction_hint')"
                        class="form-control form-control-sm"
                        id="value"
                    />
                </div>
                <div class="col-sm-4">
                    <condition-selector v-model="item.sign_condition" :required="true"/>
                </div>
                <div class="col-sm-4">
                    <span class="span-title">{{ $t('road_sign.additional_type') }}</span>
                    <select
                        v-model="item.additional_type"
                        class="form-select form-select-sm"
                        :class="{'is-invalid': !item.additional_type,'is-valid': item.additional_type !== null && item.additional_type !== ''}">
                        <option :value="null">{{ $t('road_sign.select_additional_type') }}</option>
                        <option v-for="type in getSignAdditionalType()" :key="type.value" :value="type.value">
                            {{ type.name }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-4">
                    <span class="span-title">{{ $t('road_sign.order_number') }}</span>
                    <input
                        v-model="item.order_number"
                        type="number"
                        min="0"
                        class="form-control form-control-sm"
                        id="orderNumber"
                    />
                </div>
                <div class="col-sm-4">
                    <span class="span-title">{{ $t('road_sign.sign_width') }}</span>
                    <input
                        v-model="item.width"
                        type="number"
                        min="0"
                        class="form-control form-control-sm"
                        id="signWidth"
                    />
                </div>
                <div class="col-sm-4">
                    <span class="span-title">{{ $t('road_sign.sign_height') }}</span>
                    <input
                        v-model="item.height"
                        type="number"
                        min="0"
                        class="form-control form-control-sm"
                        id="signHeight"
                    />
                </div>
            </div>

            <div class="row">
                <div class="col-sm-4">
                    <span class="span-title">{{ $t('road_sign.sign_color') }}</span>
                    <select
                        v-model="item.sign_color"
                        class="form-select form-select-sm"
                        :state="roadSignColorRequired(item.sign) ? item.sign_color != null : null"
                        id="signColor"
                    >
                        <option :value="null" disabled>{{ $t('road_sign.select_sign_color') }}</option>
                        <option v-for="item in getVelhoSignColors()" :key="item.value" :value="item.value">
                            {{ item.name }}
                        </option>
                    </select>
                </div>
            </div>
           <div class="row">
                <div class="col-sm-12 nopads mt-2">
                    <h4 class="form-header nopads mt-0">{{ $t('velho_equipment.location_spesifications') }}</h4>
                    <velho-equipment-location-details-editor
                        ref="equipmentLocationEditor"
                        :roadInfo="item"
                        :locationSpecification="item.location_specification"
                        :tracksRequired="this.roadSignTrackRequired(item.location_specification.center_area, item.location_specification.side)"
                        :sideRequired="this.roadSignSideRequired(item.location_deviation, item.road_num)"
                        :rampRequired="this.locationSpecificationRequiredRoadSign('ramps')"
                        :shoulderRequired="this.locationSpecificationRequiredRoadSign('shoulders')"
                        :platformRequired="this.locationSpecificationRequiredRoadSign('platforms')"
                        :edgeAreaRequired="this.locationSpecificationRequiredRoadSign('edge_areas')"
                        :dividerRequired="this.locationSpecificationRequiredRoadSign('dividers')"
                        :ditchBottomRequired="this.locationSpecificationRequiredRoadSign('ditch_bottoms')"
                        :centerAreaRequired="this.locationSpecificationRequiredRoadSign('center_area')"
                        :disableRule="locationSpecificationDisableRule"
                    />
                </div>
            </div>
            <div>
                <hr class="mb-0">
                <div class="row" v-if="isAddEquipmentMode">
                    <div class="col-sm-6 nopads mt-2">
                        <equipment-date
                            :text="$t('velho_equipment.start_date')"
                            v-model="item.created_at"
                        />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <span class="span-title">{{ $t('road_sign.info') }}</span>
                    <textarea
                        v-model="item.info"
                        :placeholder="$t('road_sign.info')"
                        rows="4"
                        class="form-control form-control-sm"
                        id="info"
                    ></textarea>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LocationDeviation from "@/components/velho/LocationDeviation";
import ConditionSelector from "@/components/velho/ConditionSelector";
import VelhoEquipmentLocationDetailsEditor from "@/components/velho/VelhoEquipmentLocationDetailsEditor";
import {conversionModelHelper} from "@/components/mixins/ConversionMixin";
import {restApi} from "@/components/mixins/RestApiMixin";
import {velhoHelper, deviations} from "@/components/mixins/VelhoMixin";
import {roadSignHelper} from "@/components/mixins/RoadSignMixin";
import {velhoValidationMixin} from "@/components/mixins/VelhoValidationMixin";
import {velhoRequiredMixin} from "@/components/mixins/VelhoRequiredMixin";
import EquipmentDate from "@/components/velho/EquipmentDate.vue";

const imageModules = import.meta.glob('@/assets/roadsign/**/*.{svg,png,jpg}', {eager: true});


export default {
    name: 'RoadSignEditor',
    components: {EquipmentDate, LocationDeviation, ConditionSelector, VelhoEquipmentLocationDetailsEditor },
    mixins: [roadSignHelper, conversionModelHelper, restApi, velhoHelper, velhoValidationMixin, velhoRequiredMixin],
    props: {
        item: {
            type: Object
        },
        addEquipmentEditor: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        isAddEquipmentMode() {
            return this.addEquipmentMode
        }
    },
    watch: {
        'item.type': function () {
            if (this.item.type === null) {
                this.signs = []
            } else {
                this.signs = this.getSigns(this.item.type)
            }
            delete this.item.sign;
        },
        'item.location_deviation': function () {
            // if deviation is "at the end of the road", clear side selection because it cannot be set in this case
            if(this.item.location_deviation === deviations.AT_THE_END_OF_THE_ROAD) {
                this.item.location_specification.side = null
            }
            // Side is required when deviation is given (unless it is "at the end of the road"). Clear any other location specification selections
            if(this.item.location_deviation != null) {
                this.item.location_specification.ramps = null
                this.item.location_specification.shoulders = null
                this.item.location_specification.platforms = null
                this.item.location_specification.edge_areas = null
                this.item.location_specification.ditch_bottoms = null
                this.item.location_specification.dividers = null
                this.item.location_specification.center_area = null
            }
        },
        'item.road_num': function (roadNumbervalue) {
            if(this.validateIsRoadSignLocationSpecificationNotAllowed(roadNumbervalue, this.item.location_deviation)) {
                this.item.location_specification.ramps = null
                this.item.location_specification.shoulders = null
                this.item.location_specification.platforms = null
                this.item.location_specification.edge_areas = null
                this.item.location_specification.ditch_bottoms = null
                this.item.location_specification.dividers = null
                this.item.location_specification.center_area = null
            }
        }
    },
    data() {
        return {
            signs: [],
            addEquipmentMode: this.addEquipmentEditor,
        }
    },
    methods: {
        getRoadSignImage (iconName) {
            const imagePath = `/src/assets/roadsign/${iconName}`;
            return imageModules[imagePath]?.default || imageModules[imagePath];
        },
        updateLocationDeviation(value) {
            this.item.location_deviation = value
        },
        hasSomeLocationSpecificationSet(name) {
            const ruleFields = ['side', 'ramps', 'shoulders', 'platforms', 'edge_areas', 'ditch_bottoms', 'dividers', 'center_area'];
            // Velho allow only one of these values to be selected
            const otherSelections = ruleFields.filter(field => field !== name)
            return otherSelections.some(field => this.item.location_specification[field] != null)
        },
        locationSpecificationRequiredRoadSign(name) {
            return !this.hasSomeLocationSpecificationSet(name) && this.roadSignLocationSpecificationRequired(this.item.location_deviation, this.item.road_num)
        },
        /**
         * Disable rule for location specification fields unless they are required
         * @param name - Location specification object key name
         * @returns {string}
         */
        locationSpecificationDisableRule(name) {
            // Disable side if location deviation is at the end of the road
            if(name === 'side' && this.item.location_deviation === deviations.AT_THE_END_OF_THE_ROAD) {
                return true
            }


            // If side is required, disable all other location specifications
            if(name !== 'side' && this.roadSignSideRequired(this.item.location_deviation, this.item.road_num)) {
                return true
            }

            // Location specification is not allowed if road number is >= 20 000 and location deviation is set
            if(name !== 'side' && this.validateIsRoadSignLocationSpecificationNotAllowed(this.item.road_num, this.item.location_deviation)) {
                return true
            }

            // Otherwise check that only one of the following fields are selected
            return this.hasSomeLocationSpecificationSet(name)
        },
        isValidForm: function() {
            if(!this.item) { return false }
            if(this.item.sign == null) { return false }

            if(!this.validateSignAdditionalType(this.item.additional_type)) { return false }
            if(!this.validateRoadNumber(this.item.road_num)) { return false }
            if(!this.validateRoadSection(this.item.road_sec)) { return false }
            if(!this.validateRoadDistance(this.item.distance)) { return false }
            if(!this.validateMaterial(this.item.material)) { return false }

            if(this.roadSignSideRequired(this.item.location_deviation, this.item.road_num)) {
                if(!this.validateRoadSide(this.item.location_specification.side)) { return false }
            }
            if(this.roadSignTrackRequired(this.item.location_specification.center_area, this.item.location_specification.side)) {
                if(!this.validateRoadTracks(this.item.location_specification.tracks)) { return false }
            }
            if(this.locationSpecificationRequiredRoadSign('ramps')) {
                if(!this.validateRoadNumber(this.item.location_specification.ramps)) { return false }
            }
            if(this.locationSpecificationRequiredRoadSign('shoulders')) {
                if(!this.validateRoadNumber(this.item.location_specification.shoulders)) { return false }
            }
            if(this.locationSpecificationRequiredRoadSign('platforms')) {
                if(!this.validateRoadNumber(this.item.location_specification.platforms)) { return false }
            }
            if(this.locationSpecificationRequiredRoadSign('edge_areas')) {
                if(!this.validateRoadNumber(this.item.location_specification.edge_areas)) { return false }
            }
            if(this.locationSpecificationRequiredRoadSign('dividers')) {
                if(!this.validateRoadNumber(this.item.location_specification.dividers)) { return false }
            }
            if(this.locationSpecificationRequiredRoadSign('ditch_bottoms')) {
                if(!this.validateRoadNumber(this.item.location_specification.ditch_bottoms)) { return false }
            }
            if(this.locationSpecificationRequiredRoadSign('center_area')) {
                if(!this.validateRoadNumber(this.item.location_specification.center_area)) { return false }
            }
            if(this.roadSignColorRequired(this.item.sign)) {
                if(!this.validateSignColor(this.item.sign_color)) { return false }
            }

            return true
        }
    }
}
</script>

<style scoped>
/* Multiselect doesn't support state validation */
.validationError {
    border-color: #dc3545;
}
</style>

